export { Text } from "@mantine/core";
export type { TextProps } from "@mantine/core";
export { textOverrides } from "./Text.config";
